import { useQuery } from "@tanstack/react-query";
import { ListingStatus, type ListListingsQuery } from "@hybrid-escrow/shared";
import { apiClient } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";
import { POLL } from "../lib/polling";

export function useListings(query: Partial<ListListingsQuery> = {}) {
  return useQuery({
    queryKey: queryKeys.listings(query),
    queryFn: ({ signal }) => apiClient.listListings(query, signal),
    placeholderData: (previous) => previous,
    refetchInterval: POLL.catalogue,
  });
}

export function useListing(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.listing(id ?? ""),
    queryFn: ({ signal }) => apiClient.getListing(id as string, signal),
    enabled: Boolean(id),
    // Stock and price can change while someone is looking at the page.
    refetchInterval: POLL.list,
  });
}

export function useSellerListings(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.sellerListings,
    queryFn: ({ signal }) => apiClient.getSellerListings(signal),
    enabled,
    // Auto-refresh while any of the seller's listings is mid-scan so the create/edit and
    // dashboard pages pick up SCANNING -> READY/REJECTED transitions without a manual reload.
    refetchInterval: (query) => {
      const items = query.state.data?.items ?? [];
      return items.some((item) => item.status === ListingStatus.SCANNING) ? 4_000 : POLL.list;
    },
  });
}
